import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaSf050 } from '~/endpoints/ApiTaSf050'

// State types
interface CorrectWrongInfo {
  unitAnswerList: {
    examNumber: string
    correction: string
  }[]
}
const getEmptyCorrectWrongInfo = (): CorrectWrongInfo => ({
  unitAnswerList: [],
})

// State action parameter
interface ActionParamsCorrectWrongInfo {
  unitId: string
  pieceId: string
  contentCategory: number[]
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/ReviewContentListModal',
})
export default class ReviewContentListModal extends VuexModule {
  // States
  private correctWrongInfo_ = getEmptyCorrectWrongInfo()

  // Getters
  get correctWrongInfo(): CorrectWrongInfo {
    return this.correctWrongInfo_
  }

  // Mutations
  @Mutation
  updateCorrectWrongInfo(value: CorrectWrongInfo) {
    this.correctWrongInfo_ = value
  }

  // Actions
  @Action
  clear() {
    this.context.commit('updateCorrectWrongInfo', getEmptyCorrectWrongInfo())
  }

  @Action
  async refreshCorrectWrongInfo(param: ActionParamsCorrectWrongInfo) {
    logger.trace('in: refreshCorrectWrongInfo')

    // リクエスト前に前回のストア内容をクリアする
    this.clear()

    const api = new ApiTaSf050.Api()

    // API: ApiTaSf050
    const result = await api.get<CorrectWrongInfo | null>(
      {
        query: {
          unitId: param.unitId,
          pieceId: param.pieceId,
          contentCategory: param.contentCategory,
        },
      },
      // success
      (data, _) => {
        return {
          unitAnswerList: data.unitAnswerList,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateCorrectWrongInfo', result)
  }
}
